import styled, { css } from 'styled-components';

import { device } from '@/styles/helpers';

export const ScTabBar = styled.div<{
  isModal: boolean;
}>`
  position: fixed;
  inset: auto -1px -2px;
  z-index: 113;
  display: none;

  @media (${device.tablet}) {
    display: block;
  }

  & > .body {
    background: ${({ theme }) => theme.grayDarkColor};
    position: relative;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    position: relative;
    border-radius: 24px 24px 0px 0px;
    padding: 8px 16px 20px;
    gap: 10px;

    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.64);

    @media (${device.mobileXS}) {
      gap: 6px;
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: ${({ theme }) => theme.blackColor};
      z-index: -1;
      opacity: ${({ isModal }) => (isModal ? 1 : 0)};
    }

    .item {
      position: relative;
      height: 40px;

      & svg path {
        opacity: 0.6;
      }

      & .tuple div:nth-child(even) svg path,
      & .active svg path {
        opacity: 1;
      }
    }
  }
`;

interface ScAuthButtonsProps {
  fullyVisible: boolean;
  hide?: boolean;
}

export const ScAuthButtons = styled.div<ScAuthButtonsProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;

  ${({ fullyVisible }) =>
    fullyVisible
      ? css`
          justify-content: center;
        `
      : css`
          justify-content: space-between;

          .buttonWrap {
            flex: 0 0 50%;
            max-width: 50%;
            &:first-child {
              padding: 0 8px 0 0;
            }
            &:last-child {
              padding: 0 0 0 8px;
            }
          }
          button {
            width: 100%;
            box-sizing: border-box;
          }
        `}

  .or {
    padding: 0 16px;
    ${({ fullyVisible }) =>
      !fullyVisible &&
      css`
        display: none;
      `}
  }

  @media (${device.mobileXS}) {
    flex-wrap: nowrap;
    .or {
      padding: 0 8px;
      text-align: center;
    }

    .buttonWrap {
      flex: 0 0 50%;
      max-width: 50%;
      box-sizing: border-box;
      button {
        width: 100%;
      }
    }
    ${({ fullyVisible }) =>
      !fullyVisible &&
      css`
        .buttonWrap {
          &:first-child {
            padding: 0 4px 0 0;
          }
          &:last-child {
            padding: 0 0 0 4px;
          }
        }
      `}
  }
  @media (max-width: 412px) {
    width: 100%;
    button {
      font-size: 13px;
    }
  }
`;
